
<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher(); 

    let mouseDownAction = () => {
		dispatch('mousedown');
        isOpen = !isOpen;
	};

    let isOpen = false;
    export let isfiltering = false;
    export let title = "Filter Component";
</script>

<h5><span class="filter {isfiltering ? "active" : ""}" on:mousedown={mouseDownAction}>{title} <i class="fa fa-chevron-{isOpen ? "up" : "down"} ml-2"></i></span></h5>

<style>
    .filter {
        transition: all 0.2s ease-in-out;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 4px 2px #00aec92a;
        padding: 0.6em;
        cursor: pointer;
    }

    .filter.active{
        border: 2px solid var(--blue);
    }
</style>